// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607140025/js/" + chunkId + "." + {"44":"afef4719","225":"a464bdc6","481":"be8b2fd2","486":"da52d1f7","770":"325e8425"}[chunkId] + ".0.3360716219150581.chunk.js";
};